<template>
  <div class="search">
    <div class="container">
      <a-input-search
        v-model:value="keyword"
        @search="pushSearchPage"
        placeholder="請輸入關鍵字"
        style="padding: 10px; border-radius: 15px"
        title="搜尋框"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "HomeSearch",
  setup() {
    const router = useRouter();
    const keyword = ref("");
    const pushSearchPage = () => {
      router.push(`/search?keyword=${keyword.value}`);
    };
    return { keyword, pushSearchPage };
  },
});
</script>

<style lang="scss" scoped>
.search {
  padding-bottom: 40px;
  @include md {
    padding-bottom: 20px;
  }
  .ant-input-affix-wrapper {
    width: 35%;
    border: 1px solid #ccc;
    @include xl {
      width: 60%;
    }
    @include lg {
      width: 70%;
    }
    @include xs {
      width: 90%;
    }
  }
}
</style>
